module.exports = __webpack_public_path__ + "static/bruno-blk-e2bcc7a3f1240d8e34cff1999f2a8634.jpeg";